import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Database } from 'lucide-react';

export default function DatabaseMigration() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Database className="h-5 w-5" />
          Schema Comparison & Migration
        </CardTitle>
        <CardDescription>
          Export schema from new PC, upload to old PC, and compare schemas to
          migrate table structure while preserving data
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="text-center py-8">
          <Database className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
            Schema Comparison & Migration
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            Use the advanced schema comparison tool to safely migrate your
            database structure between different environments while preserving
            all existing data.
          </p>
          <div className="bg-blue-50 dark:bg-blue-950 rounded-lg p-4 text-left">
            <h4 className="font-medium text-blue-900 dark:text-blue-100 mb-2">
              How it works:
            </h4>
            <ol className="text-sm text-blue-800 dark:text-blue-200 space-y-1">
              <li>1. Export current schema from your new PC</li>
              <li>2. Upload the schema file to your old PC</li>
              <li>3. Compare schemas to identify differences</li>
              <li>4. Generate migration scripts to update structure</li>
              <li>5. Apply changes while preserving all data</li>
            </ol>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
